import { getReturnResponseResult } from './op-invoice-return-response.js';

class OpInvoiceDetails extends HTMLElement {
  constructor() {
    super();
    this.retailerId = this.dataset.retailerId;
    this.invoiceId = new URL(window.location.href).searchParams.get('id');
    this.endpoint = `/apps/ax/order-portal/retailers/${this.retailerId}/invoices/${this.invoiceId}`;
    this.fetchInvoiceDetails();

    this.handleActions();
  }

  fetchInvoiceDetails() {
    this.classList.add('op-loading');
    fetch(this.endpoint)
      .then(response => response.json())
      .then(data => {
        if (data.invoice) {
          this.invoice = data.invoice;
          const showReturnBtn = this.querySelector('[data-action="show-return-elements"]');
          if (this.invoice.type === 'CREDIT_NOTE' || !this.hasReturnableLines()) {
            showReturnBtn?.setAttribute('disabled', 'disabled');
          }
          // comment below line since client want to show all return reasons again
          // this.updateReturnReasonOptions();
          this.renderInvoiceSummary();
          this.renderInvoiceProducts();
        } else {
          console.error('Invoice not found');
          if (document.querySelector('.op-invoice-details .page__content')) {
            document.querySelector('.op-invoice-details .page__content').innerHTML = `<div class="rte article-content mt-12 mx-auto">${window.theme.strings.opInvoiceDetails.invoiceNotFound}</div>`;
          }
          if (document.querySelector('.op-invoice-details .page__subtitle')) {
            document.querySelector('.op-invoice-details .page__subtitle').classList.add('hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error fetching invoice details:', error);
        if (document.querySelector('.op-invoice-details .page__content')) {
          document.querySelector('.op-invoice-details .page__content').innerHTML = `<div class="rte article-content mt-12 mx-auto">${window.theme.strings.opInvoiceDetails.invoiceNotFound}</div>`;
        }
        if (document.querySelector('.op-invoice-details .page__subtitle')) {
          document.querySelector('.op-invoice-details .page__subtitle').classList.add('hidden');
        }
      })
      .finally(() => {
        this.classList.remove('op-loading');
      });
  }

  renderInvoiceSummary() {
    const invoice = this.invoice;
    
    this.querySelectorAll('.invoice-number').forEach(element => {
      element.textContent = invoice.invoiceId;
    });

    let invoiceCreatedAt = '';
    if (invoice.createdAt) {
      invoiceCreatedAt = invoice.createdAt.replaceAll('/', '-');
      if (invoiceCreatedAt.split('-').length == 3 && invoiceCreatedAt.split('-')[0].length == 4) {
        invoiceCreatedAt = invoiceCreatedAt.split('-').reverse().join('-');
      }
    }
    this.querySelectorAll('.invoice-date').forEach(element => {
      element.textContent = invoiceCreatedAt;
    });

    this.querySelectorAll('.invoice-due-date').forEach(element => {
      element.textContent = window.convertDateToDanishFormat(invoice.dueDate);
    });

    this.querySelectorAll('.invoice-customer-email').forEach(element => {
      element.textContent = invoice.retailEmail;
    });

    this.querySelectorAll('.invoice-billing-address').forEach(element => {
      let address = invoice.customer?.invoiceAddress;
      if (address) {
        element.innerHTML = `<div>${address.companyName ? address.companyName + ', ' : ''}${address.address1 || ''}</div><div>${address.city || ''} ${address.postalCode || ''}</div>${address.address2 ? `<div>${address.address2}</div>` : ''}`;
      } else {
        element.innerHTML = '-';
      }
    });

    this.querySelectorAll('.invoice-delivery-address').forEach(element => {
      let address = invoice.customer?.shipToAddress;
      if (address) {
        element.innerHTML = `<div>${address.companyName ? address.companyName + ', ' : ''}${address.address1 || ''}</div><div>${address.city || ''} ${address.postalCode || ''}</div>${address.address2 ? `<div>${address.address2}</div>` : ''}`;
      } else {
        element.innerHTML = '-';
      }
    });

    this.querySelectorAll('.invoice-total-price-ex-vat').forEach(element => {
      element.textContent = invoice.totalPriceExVat ? invoice.totalPriceExVat.replace('.', ',') + ' DKK' : '';
    });

    this.querySelectorAll('.invoice-total-vat').forEach(element => {
      element.textContent = invoice.vat ? invoice.vat.replace('.', ',') + ' DKK' : '';
    });

    this.querySelectorAll('.invoice-total-price').forEach(element => {
      element.textContent = invoice.totalPriceIncVat ? invoice.totalPriceIncVat.replace('.', ',') + ' DKK' : '';
    });
  }

  async renderInvoiceProducts() {
    const invoice = this.invoice;
    if (invoice && invoice.documentLines && invoice.documentLines.length > 0  ) {
      let tableData = [];
      let productExtraData = await this.fetchExtraData(invoice.documentLines.map(line => line.sku));
      invoice.documentLines.forEach(line => {
        let product = productExtraData.find(product => product.variants.find(variant => variant.sku === line.sku));
        let variant = product?.variants.find(variant => variant.sku === line.sku) || null;
        let lineReturned = parseInt(line.returned) || 0;
        let returnFormHtml = '';
        if (this.isLineReturnable(line)) {
          returnFormHtml = `
            <div class="return-form-item grid grid-flow-col gap-3 items-center">
              <quantity-input class="inline-block">
                <div class="qty-input qty-input--combined inline-flex items-center w-full">
                  <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus" aria-controls="op-oi-vid-${line.sku}">
                    <span class="visually-hidden">Decrease quantity</span>
                  </button>
                  <input type="number" class="qty-input__input input" id="op-oi-vid-${line.sku}" name="quantity" min="0" step="1" ${line.quantity ? `max="${line.quantity - lineReturned}"` : ''} value="0" 
                    data-order-id="${line.webshopOrderId}" data-sku="${line.sku}" data-webshop-line-id="${line.webshopLineId}" data-webshop-fulfillment-line-id="${line.webshopFulfillmentLineId || null}" data-unit-price-ex-vat="${line.unitPriceExVat}" data-erp-line-id="${line.erpLineId}">
                  <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus" aria-controls="op-oi-vid-${line.sku}">
                    <span class="visually-hidden">Increase quantity</span>
                  </button>
                </div>
              </quantity-input>
              <textarea name="return-comment" id="return-comment-${line.sku}" placeholder="${window.opReturnFormTexts.comment}" class="w-full input"></textarea>
            </div>
          `;
        } else {
          returnFormHtml = `
            <div class="return-form-item return-form-item--disabled text-theme-light italic">
              ${window.theme.strings.opInvoiceDetails.lineCannotBeReturned}
            </div>
          `;
        }

        let imageHtml = variant?.featuredImage ? `<img src="${variant.featuredImage}" alt="${product.productTitle}" class="op-product-image">` : '';
        if (!imageHtml) {
          imageHtml = product?.productImage ? `<img src="${product.productImage}" alt="${product.productTitle}" class="op-product-image">` : '';
        }

        let nameAndImageHtml = line.name;
        if (product && variant) {
          nameAndImageHtml = `<div class="flex gap-2">
            ${imageHtml ? `<a href="/products/${product.productHandle}" target="_blank">${imageHtml}</a>` : ''}
            <div class="flex flex-col">
              <a href="/products/${product.productHandle}" target="_blank" class="no-underline">${product.productTitle}</a>
              ${product.categoryName ? `<div class="font-normal">${product.categoryName}</div>` : ''}
            </div>
          </div>`;
        }

        let skuAndBarcodeHtml = `<div class="flex flex-col">
            <div>${line.sku}</div>
            ${variant?.barcode ? `<div>${variant.barcode}</div>` : ''}
          </div>`;

        tableData.push([
          nameAndImageHtml,
          skuAndBarcodeHtml,
          line.shippingDate ? window.convertDateToDanishFormat(line.shippingDate) : '',
          line.unitPriceExVat ? line.unitPriceExVat.replace('.', ',') : '',
          line.quantity ? line.quantity : '',
          lineReturned,
          line.unitPriceExVat && line.quantity ? (line.unitPriceExVat * line.quantity).toFixed(2).replace('.', ',') : '',
          returnFormHtml
        ]);
      });
      const table = this.querySelector('#op-invoice-details-table');
      if (table && tableData.length && typeof table.setRows === 'function') {
        table.classList.remove('hidden');
        table.setRows(tableData);
      }
    }
  }

  async fetchExtraData(allSkus) {
    const BATCH_SIZE = 20;
    const uniqueSkus = Array.from(new Set(allSkus.filter(sku => !!sku)));
    const batches = [];
    for (let i = 0; i < uniqueSkus.length; i += BATCH_SIZE) {
      batches.push(uniqueSkus.slice(i, i + BATCH_SIZE));
    }
    const results = await Promise.all(batches.map(batch => {
      const searchQuery = batch.map(sku => `variants.sku:${sku}`).join(' OR ');
      return fetch(`/search?q=${encodeURIComponent(searchQuery)}&type=product&view=product-details&options[prefix]=none`)
        .then(response => response.json());
    }));
    const extraData = [];
    const seenProductIds = new Set();
    for (const batchResult of results) {
      if (!Array.isArray(batchResult)) continue;
      for (const product of batchResult) {
        const key = product?.id || product?.productHandle;
        if (key && seenProductIds.has(key)) continue;
        if (key) seenProductIds.add(key);
        extraData.push(product);
      }
    }
    return extraData;
  }

  handleActions() {
    this.addEventListener('change', (event) => {
      const input = event.target.closest('input[name="quantity"]');
      if (input) {
        const max = parseInt(input.getAttribute('max'), 10);
        const min = parseInt(input.getAttribute('min'), 10) || 0;
        let value = parseInt(input.value, 10) || 0;
        if (!isNaN(max) && value > max) value = max;
        if (value < min) value = min;
        input.value = value;
      }
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-action="toggle-line-details"]')) {
        event.preventDefault();
        event.target.closest('.op-table-row').classList.toggle('show-more-data');
      }
      if (event.target.closest('[data-action="show-return-elements"]')) {
        event.preventDefault();
        if (this.invoice.type === 'CREDIT_NOTE') {
          alert(window.theme.strings.opInvoiceDetails.creditNoteCannotBeReturned);
        } else if (!this.hasReturnableLines()) {
          alert(window.theme.strings.opInvoiceDetails.invoiceCannotBeReturned);
        } else {
          this.classList.add('show-return-elements');
        }
      }
      if (event.target.closest('[data-action="submit-return"]')) {
        event.preventDefault();
        this.handleReturnSubmit(event.target.closest('[data-action="submit-return"]'));
      }
      if (event.target.closest('[data-action="cancel-return"]')) {
        event.preventDefault();
        this.classList.remove('show-return-elements');
        this.querySelectorAll('.op-table-row.active').forEach(item => {
          item.classList.remove('active');
        });
      }
      if (event.target.closest('.show-return-elements .op-table-row > div:first-child')) {
        event.preventDefault();
        const row = event.target.closest('.show-return-elements .op-table-row');
        if (!row.querySelector('.return-form-item:not(.return-form-item--disabled)')) {
          return;
        }
        row.classList.toggle('active');
      }
    });
  }

  isLineReturnable(line) {
    return Boolean(line && (line.webshopOrderId || line.erpLineId));
  }

  hasReturnableLines() {
    return Array.isArray(this.invoice?.documentLines) &&
      this.invoice.documentLines.some(line => this.isLineReturnable(line));
  }

  isHistoricalInvoice() {
    return Array.isArray(this.invoice?.documentLines) &&
      this.invoice.documentLines.some(line => !line.webshopOrderId);
  }

  updateReturnReasonOptions() {
    if (!this.isHistoricalInvoice()) return;

    const hiddenReasons = ['Defekt DSV', 'Transport', 'Manko'];
    const returnReasonSelect = this.querySelector('.op-return-reason select');
    returnReasonSelect?.querySelectorAll('option').forEach(option => {
      if (hiddenReasons.includes(option.value)) {
        option.remove();
      }
    });
  }

  showReturnError(message, opener = null) {
    const popup = this.querySelector('ir-popup');
    if (popup?.show) {
      popup.show({
        type: 'info',
        title: window.theme.strings.opInvoiceDetails.returnFailedTitle,
        message
      }, opener);
      return;
    }

    alert(message);
  }

  handleReturnSubmit(submitReturnBtn) {
    if (this.isSubmittingReturn) return;
    this.isSubmittingReturn = true;
    try {
      let returnReason = this.querySelector('.op-return-reason select').value;
      if (!returnReason) {
        throw new Error(window.theme.strings.opInvoiceDetails.selectReturnReason);
      }

      if (this.querySelectorAll('.op-table-row.active').length <= 0) {
        throw new Error(window.theme.strings.opInvoiceDetails.selectAtLeastOneItem);
      }
      let returnItems = [];
      this.querySelectorAll('.op-table-row.active .return-form-item').forEach(item => {
        let input = item.querySelector('input[name="quantity"]');
        let max = parseInt(input.getAttribute('max'), 10);
        let quantity = parseInt(input.value, 10);
        if (!quantity) {
          throw new Error(window.theme.strings.opInvoiceDetails.missingQuantity);
        }
        if (!isNaN(max) && quantity > max) {
          quantity = max;
          input.value = max;
        }
        let orderId = input.getAttribute('data-order-id');
        let sku = input.getAttribute('data-sku');
        let lineItemId = input.getAttribute('data-webshop-line-id');
        let erpLineId = input.getAttribute('data-erp-line-id');
        let fulfillmentLineItemId = input.getAttribute('data-webshop-fulfillment-line-id');
        let unitPriceExVat = input.getAttribute('data-unit-price-ex-vat');

        if (erpLineId != 'null' || (orderId != 'null' && sku != 'null' && lineItemId != 'null' && unitPriceExVat != 'null')) {
          returnItems.push({
            shopifyOrderId: orderId == 'null' ? null : orderId,
            sku: sku == 'null' ? null : sku,
            lineItemId: lineItemId == 'null' ? null : lineItemId,
            erpLineId: erpLineId == 'null' ? null : erpLineId,
            fulfillmentLineItemId: fulfillmentLineItemId == 'null' ? null : fulfillmentLineItemId,
            unitPriceExVat: unitPriceExVat == 'null' ? null : unitPriceExVat,
            quantity: quantity == 'null' ? null : quantity,
            returnReasonNote: item.querySelector('textarea[name="return-comment"]').value
          });
        }
      });

      if (returnItems.length > 0) {
        let body = {
          "currency": "DKK",
          "axCause": returnReason,
          "returnLineItems": returnItems
        }
        submitReturnBtn.classList.add('is-loading');
        submitReturnBtn.setAttribute('disabled', '');
        fetch(`/apps/ax/order-portal/retailers/${this.retailerId}/invoices/${this.invoiceId}/returns`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(async response => {
          let data = null;
          try {
            data = await response.json();
          } catch (error) {
            console.error('Unable to parse return response:', error);
          }

          const result = getReturnResponseResult(
            response.ok,
            data,
            window.theme.strings.opInvoiceDetails.returnSubmittedError
          );
          if (result.success) {
            alert(window.theme.strings.opInvoiceDetails.returnSubmittedSuccessfully);
            window.location.reload();
          } else {
            if (result.technicalError) {
              console.error('Return creation failed:', {
                technicalError: result.technicalError
              });
            }
            this.showReturnError(result.errorMessage, submitReturnBtn);
          }
        })
        .catch(error => {
          console.error('Error submitting return:', error);
          this.showReturnError(
            window.theme.strings.opInvoiceDetails.returnSubmittedError,
            submitReturnBtn
          );
        })
        .finally(() => {
          submitReturnBtn.classList.remove('is-loading');
          submitReturnBtn.removeAttribute('disabled');
          this.isSubmittingReturn = false;
        })
      } else {
        this.isSubmittingReturn = false;
      }
    } catch (error) {
      alert(error);
      this.isSubmittingReturn = false;
    }
  }
}

customElements.define('op-invoice-details', OpInvoiceDetails);